import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/landingContent";
export function BonusesSection() {
  return <section className="bg-plum-dark px-0 py-14 sm:px-4 sm:py-20" aria-labelledby="bonuses-title" data-id="element-102" data-mp="qek1zy1u6x3q">
      <div className="px-4" data-id="element-103" data-mp="vc2bpqnohgcs">
        <SectionHeading tone="dark" eyebrow="Five exclusive bonuses — included free today" title={<span id="bonuses-title" data-id="element-105" data-mp="1o11198u4rks4">Get even more practical value from the system</span>} intro="These bonuses complement the six main volumes and give you additional ways to organize your consultations." data-id="element-104" data-mp="1j1eot1m4m8kd" />
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-8" data-id="element-106" data-mp="1e93nbubqmepp">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white sm:rounded-3xl" data-id="element-107" data-mp="21zh6evcch385">
            <div className="flex items-center justify-between gap-3 bg-rose px-4 py-3 text-white sm:px-6" data-id="element-108" data-mp="26s0rseh9x2ni">
              <span className="flex items-center gap-2 text-sm font-extrabold uppercase tracking-wider" data-id="element-109" data-mp="2m6ac40w3el2y">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-110" data-mp="2h7z13mu2a4j5" />
                Bonus #{b.number}
              </span>
              <span className="rounded-full bg-white px-3 py-1 text-xs font-extrabold uppercase text-cta" data-id="element-111" data-mp="2vxenyrqh1ptk">
                Included free
              </span>
            </div>
            <img src={b.image} alt={`${b.title} mockup`} className="block w-full bg-white" loading="lazy" data-id="element-112" data-mp="34up3wqe8i34t" />
            <div className="px-4 pb-6 sm:px-7" data-id="element-113" data-mp="2zwdtoek11qm2">
              <h3 className="font-serif text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-114" data-mp="3etwg3a98frqc">{b.title}</h3>
              <p className="mt-1.5 font-serif text-lg font-semibold text-plum" data-id="element-115" data-mp="39ujo6b3i7ugw">{b.subtitle}</p>
              <p className="mt-3 text-[16px] leading-relaxed text-muted" data-id="element-116" data-mp="1kfn36u5tptdh">{b.description}</p>
              <ul className="mt-4 space-y-2" data-id="element-117" data-mp="1fhbs6g3slcto">
                {b.items.map(item => <li key={item} className="flex gap-2.5 text-[16px] leading-snug text-ink" data-id="element-118" data-mp="2557ivtcmgs3c">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-119" data-mp="296t0tt40jwke" />
                    {item}
                  </li>)}
              </ul>
              {b.note && <p className="mt-4 text-sm italic leading-relaxed text-muted" data-id="element-120" data-mp="2e88l3iyd9z1q">{b.note}</p>}
              <div className="mt-5 flex items-center justify-between rounded-2xl bg-blush px-4 py-3" data-id="element-121" data-mp="2j2w1euj7vn58">
                <span className="text-sm font-semibold text-muted" data-id="element-122" data-mp="2o28ys97pscm2">
                  Reference value: <s className="text-red-600" data-id="element-123" data-mp="2s3u499hx5om8">${b.value}</s>
                </span>
                <span className="font-serif text-xl font-extrabold text-cta" data-id="element-124" data-mp="2wwx41zdahuav">FREE</span>
              </div>
            </div>
          </article>)}
      </div>

      <div className="px-4" data-id="element-125" data-mp="36v32g6zw0iaz">
        <CtaButton className="mt-10" label="I want the volumes + 5 free bonuses" data-id="element-126" data-mp="36vurt02w5jst" />
      </div>
    </section>;
}